var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 桥接页面 "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }